module.exports = __webpack_public_path__ + "media/images/icon_nav_month-a80dc9960324f8323e6a4ce8225fe2ca.svg";